export default __webpack_public_path__ + "static/media/misc-fireplaceA-2048w.04b7f282.avif";